type BrandLockupProps = {
  context?: "sidebar" | "login";
};

export function BrandLockup({ context = "sidebar" }: BrandLockupProps) {
  return (
    <div className={`wyx-brand-lockup ${context === "login" ? "login" : "compact"}`} aria-label="WYX AlphaOS 智能投研系统">
      <div className="wyx-logo-plate" aria-hidden="true">
        <span className="wyx-mark">W</span>
        <span className="wyx-wordmark">WYX</span>
      </div>
      <div className="wyx-product-name"><strong>ALPHAOS</strong><span>智能投研系统</span></div>
    </div>
  );
}
